import { UserDataService } from './user-data.service';

import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { LoginService } from 'src/app/core/services/ login.service';
import { AuthResponse } from '../../shared/models/AD/auth-response.model';
import { RolesEnum } from '../../shared/constants/role.enum';
import { CookieService } from "src/app/core/services/cookie.service";
import { User } from 'src/app/core/models/user.model';

@Injectable({
	providedIn: 'root'
})
export class UserAuthService {
	private readonly retrievedLoginDetailsSubject = new BehaviorSubject<boolean>(false);
	loginComplete$ = this.retrievedLoginDetailsSubject.asObservable();

	constructor(
		private readonly userDataService: UserDataService,
		private readonly cookieService: CookieService,
		private readonly loginSvc: LoginService,
		private readonly router: Router
	) { }

	isAuthenticated(): boolean {
		const adAcct = this.cookieService.get('authResponse');
		return adAcct != null && adAcct?.length > 0;
	}

	isLoginComplete(): boolean {
		return this.retrievedLoginDetailsSubject.value;
	}

	setLoginComplete(authComplete: boolean): void {
		this.retrievedLoginDetailsSubject.next(authComplete);
	}

	getAdToken(): string {
		const adAcct = this.cookieService.get('authResponse');

		if (adAcct) {
			let authModel: AuthResponse = JSON.parse(adAcct);
			return authModel.accessToken;
		}

		return null;
	}

	setLdapToken(accessToken: string) {
		const adAcct = this.cookieService.get('authResponse');

		if (adAcct) {
			let authModel: AuthResponse = JSON.parse(adAcct);
			authModel.accessToken = accessToken;

			this.cookieService.set('authResponse', JSON.stringify(authModel));
		}
	}

	getLdapRefreshToken(): string {
		const adAcct = this.cookieService.get('authResponse');

		if (adAcct) {
			let authModel: AuthResponse = JSON.parse(adAcct);
			return authModel.refreshToken
		}

		return null;
	}

	getUsername(): string {
		let adAcct = this.cookieService.get('authResponse');
		let authModel: AuthResponse = JSON.parse(adAcct);

		return authModel.username;
	}

	async getUserDetails(): Promise<User> {
		let user = await this.userDataService.getUser();
		if (user?.displayName?.length <= 0)
			user.displayName = this.getUsername();

		return user;
	}

	getRoles(): RolesEnum[] {
		let role: string = this.loginSvc?._role;

		if (role)
			return [RolesEnum[role as keyof typeof RolesEnum]];

		return [];
	}

	async hasProfilePhoto(): Promise<boolean> {
		let user = await this.userDataService.getUser();
		return user?.image != null;
	}

	async getProfilePhoto(): Promise<SafeUrl> {
		let user = await this.userDataService.getUser();
		return user?.image;
	}

	async getAdGroups(): Promise<string[]> {
		let user = await this.userDataService.getUser();
		return user.adGroupNames;
	}

	async loadAdUser(payload: AuthResponse) {
		let user = await this.userDataService.getUser();
		user.displayName = payload.username;
		this.cookieService.set('authResponse', JSON.stringify(payload));
	}

	removeToken() {
		this.cookieService.delete('authResponse', '/');
		this.cookieService.deleteAll();
	}

	clearUserDetails() {
		this.userDataService.clearUser();
	}
}